import { Injectable } from '@angular/core';
import { ApiService } from "@biletix/core/services/api.service";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { ApiResponse } from "@biletix/core/models/api-response";
import { BuildInfo } from '../models/build-info';
import { map } from 'rxjs/operators';
import { VersionInfo } from '../models/version-info';
import { BuildVersionResponse } from '../models/build-version-response.dto';


@Injectable({
  providedIn: 'root'
})
export class ActuatorService {

  private path: string = "/actuator/info";

  constructor(private apiService: ApiService,
    private httpClient: HttpClient
  ) {
  }


  getAllBuildInfos(): Observable<BuildVersionResponse> {
    const url = this.apiService.getCrmApiHost() + '/api/v1/administration/all-build-versions';
    return this.httpClient.get<BuildVersionResponse>(url);
  }


  getCrmapiInfo(): Observable<BuildInfo> {
    const url = this.apiService.getCrmApiHost() + '/actuator/info';
    return this.httpClient.get<BuildInfo>(url);
  }


  getIsmapiInfo(): Observable<BuildInfo> {
    const url = this.apiService.getIsmApiHost() + '/actuator/info';
    return this.httpClient.get<BuildInfo>(url);
  }

  getWtsapiInfo(): Observable<BuildInfo> {
    const url = this.apiService.getWtsApiHost() + '/actuator/info';
    return this.httpClient.get<BuildInfo>(url);
  }

  getKafkaapiInfo(): Observable<BuildInfo> {
    const url = this.apiService.getCrmApiHost() + '/api/v1/kafdata/getKafkaApiActuator';
    return this.httpClient.get<ApiResponse<BuildInfo>>(url).pipe(
      map(response => response.data)
    );
  }


  getPaymentApiInfo(): Observable<BuildInfo> {
    const url = this.apiService.getPaymentApiHost() + '/actuator/info';
    return this.httpClient.get<BuildInfo>(url);
  }

  getPaymentWebClientInfo(): Observable<VersionInfo> {
    const url = this.apiService.getPaymentClientHost() + '/version.json';
    return this.httpClient.get<VersionInfo>(url);
  }


}
